import { hasCompleteProfile } from "@/modules/onboarding/context";
import type { ProfileData } from "@/modules/onboarding/context/OnboardingContext";
import type { Models } from "api/types";

export function profileDataFromUser(
  user: Models<"UserModel1"> | null | undefined,
): ProfileData | null {
  if (!user) return null;

  const profile: ProfileData = {
    firstName: user.firstName || undefined,
    lastName: user.lastName || undefined,
    email: user.email || undefined,
    dateOfBirth: user.dateOfBirth || undefined,
    gender: user.gender || undefined,
  };

  if (!hasCompleteProfile(profile)) return null;

  return profile;
}

export function getPostWebAuthVerifyPath(user: Models<"UserModel1"> | null | undefined): string {
  if (user?.completedProfile) {
    return "/home?fromSignIn=true";
  }

  if (profileDataFromUser(user)) {
    return "/signin/location";
  }

  return "/signin/name";
}
